import React, { forwardRef, useImperativeHandle, useRef } from 'react';
export function withWrap(Comp) {
    return forwardRef((props, ref) => {
        return React.createElement(Comp, Object.assign({}, props, { ref: ref }));
    });
}
export function withNativeElementWrap(Comp, refFunctions, preventFunctions) {
    return forwardRef((props, ref) => {
        const nativeButtonRef = useRef(null);
        useImperativeHandle(ref, () => {
            const { nativeElement, ...rest } = nativeButtonRef.current;
            refFunctions?.forEach((func) => {
                if (!nativeElement[func]) {
                    nativeElement[func] = rest[func];
                }
            });
            return nativeElement;
        });
        const innerProps = {};
        if (props.__designMode === 'design') {
            preventFunctions?.forEach((func) => {
                innerProps[func] = undefined;
            });
        }
        return React.createElement(Comp, Object.assign({}, props, innerProps, { ref: nativeButtonRef }));
    });
}
export function withWrapInput(Comp) {
    return (props, ref) => {
        return React.createElement(Comp, Object.assign({}, props, { ref: ref }));
    };
}
export function withSingleFunctionChild(Comp) {
    return (props) => {
        const { children } = props;
        let node;
        if (typeof children === 'function') {
            node = children;
        }
        if (Array.isArray(children) && children.length === 1 && typeof children[0] === 'function') {
            node = children[0];
        }
        if (node) {
            return React.createElement(Comp, Object.assign({}, props), node);
        }
        return React.createElement("div", null, children);
    };
}
export const handleDesignModeClick = (Comp) => {
    return (props) => {
        const extraProps = {};
        if (props.__designMode) {
            extraProps.open = false;
        }
        return React.createElement(Comp, Object.assign({}, props, extraProps));
    };
};
